import { post } from 'core/helpers/fetch';
import {
  CREATE_WHOISIT_INSTANCE_STARTED,
  CREATE_WHOISIT_INSTANCE_SUCCEED,
  CREATE_WHOISIT_INSTANCE_FAILED,
} from 'app/games/whoisit/reducers/instances';

function createInstance() {
  return async dispatch => {
    dispatch({ type: CREATE_WHOISIT_INSTANCE_STARTED });
    try {
      const createdInstance = await dispatch(post('/games/whoisit/instances'));
      dispatch({ type: CREATE_WHOISIT_INSTANCE_SUCCEED, payload: { instance: createdInstance } });
      return createdInstance;
    } catch (exception) {
      dispatch({ type: CREATE_WHOISIT_INSTANCE_FAILED, payload: { exception } });
      throw exception;
    }
  };
}

export default createInstance;
